import { graphql } from "../generated"

// Export request queries

export const queryExportCertificateBase = graphql(`
  query queryExportCertificateBase($id: ID!) {
    exportCertificateRequest(id: $id) {
      id
      commodity
      status
      certificateType
      destination {
        id
      }
    }
  }
`)

export const queryExportCertificateDetails = graphql(`
  query queryExportCertificateDetails($id: ID!) {
    exportCertificateRequest(id: $id) {
      id
      status
      statusLabel
      certificateNumber
      statusNotes
      replacing {
        id
        certificateNumber
      }
      replacedBy {
        id
        status
        certificateNumber
      }
    }
  }
`)

export const downloadExportCerificatesData = graphql(`
  query downloadExportCertificates(
    $startDate: AWSDateTime
    $endDate: AWSDateTime
  ) {
    downloadExportCertificates(startDate: $startDate, endDate: $endDate) {
      url
      filename
    }
  }
`)

export const getExportRequestDetails = graphql(`
  query GetExportRequestDetails($id: ID!) {
    getExportReqDetails(input: { id: $id }) {
      templateId
      templateCode
      template {
        id
        code
        majorVersion
      }
      version
      attributes {
        address {
          id
          name
        }
        phytoSchemeControl {
          id
          name
        }
        phytoCertSubType {
          id
          name
        }
        phytoStatementOfRelabelling
        inspectionDate
        letterOfCreditRefCode {
          id
          name
        }
        phytoPackhouse
        phytoLotRefNumber
        importPermitNumbers
        orgCertRefCode
        issuingAuthority {
          id
          name
        }
        halalAuditor {
          id
          name
        }
        brandName {
          id
          name
        }
        numberOfPackagesContainers {
          id
          name
        }
        contractNo {
          id
          name
        }
        halalCertificateNumber {
          id
          name
        }
        sanitoryCertificateNumber {
          id
          name
        }
        cnInspection {
          id
          name
        }
        administrativeTerritorialUnit {
          id
          name
        }
        scope {
          id
          name
        }
        manufacturerRegistration {
          id
          name
        }
        manifacturingpremisesname {
          id
          name
        }
        productDescription {
          id
          name
        }
        purposeBR {
          id
          name
        }
        netWeightInWords {
          id
          name
        }
        euTransit {
          id
          name
        }
        exporterRef {
          id
          name
        }
        expRef {
          id
          name
        }
        markingofsealontransportcontai {
          id
          name
        }
        nameRegistrationandAddressofse {
          id
          name
        }
        numberOfDoses {
          id
          name
        }
        numberOfEmbryos {
          id
          name
        }
        placeandDateofQuarantine
        transport {
          id
          name
        }
        forImportorAdmission {
          id
          name
        }
        categoryOfGoods {
          id
          name
        }
        euCommodityCode {
          id
          name
        }
        summaryofRecordsfor {
          id
          name
        }
        issuingAuthority1 {
          id
          name
        }
        shipStores
        lot {
          id
          name
        }
        edReference {
          id
          name
        }
        exporterSignature {
          id
          name
        }
        exportingCountryId {
          id
          name
        }
      }
      printDetails {
        officialPrinted
        reasonForReprinting
      }
      certificateNumber
      requiresAttention
      id
      replacedById
      replacesId
      certificateNumberReplacedById
      certificateNumberReplacesId
      overseasAuthorityInvolved
      consignor {
        id
        name
        addresses {
          city
          country
          countryCode
          lines
          postCode
          state
        }
        registrationId
      }
      requestName
      status
      substatus
      outputTranslationLanguages
      reasonForStatusChange
      reasonCategories
      replacedById
      overseasAuthorityInvolved
      urgency {
        id
        name
      }
      commodity {
        id
      }
      destinationCountry {
        id
        name
      }
      verifyingAgencyId
      certifyingAgencyId {
        id
        name
      }
      officialStatement
      additionalDeclaration
      externalConsignor {
        address {
          city
          lines
          postCode
          countryCode {
            id
            name
          }
        }
        id
        name
      }
      importer {
        name
        address {
          city
          postCode
          countryCode {
            id
            name
          }
          lines
          state
        }
        id
        representative
      }
      transitCountries {
        id
        name
      }
      destinationParty {
        name
        id
        address {
          city
          country {
            id
            name
          }
          state
          postCode
          lines
          countryCode {
            name
            id
          }
        }
      }
      transport {
        transportMode {
          id
          name
        }
        loadingPort {
          id
          name
        }
        inspectionPort {
          id
          name
        }
        finalDestination {
          id
          name
        }
        dischargePort {
          id
          name
        }
        departureDate
        conveyanceReference
        carrierName
        expectedArrivalDate
      }
      customsTransitAgent {
        id
        name
        address {
          lines
          city
          countryCode {
            id
            name
          }
          postCode
          state
        }
      }
      supportingDocuments {
        id
        b2gFile {
          extensionType
          name
        }
        comment
        documentReferenceNumber
      }
      printDetails {
        officialPrinted
        reasonForReprinting
      }
      thirdPartyConsignor
      thirdParty {
        id
        name
        registrationId
      }
      unofficialInformation
      uniqueConsignmentReference
      officialStatement
      deliveryDispatchDetails {
        id
        name
      }
      deliveryDetails {
        id
        name
      }
      signingOffice {
        id
        name
      }
      approvedCertificateEmailAddresses
      productItemGroupDetails {
        products {
          id
          productDeclaration
          itemDescription {
            id
            name
          }
          exhausted
          classification {
            classificationCode
            classificationName
            createdAt
            fieldUniqueId
            id
            itemCode
            updatedAt
            value
          }
          sequenceNumber
          eligibilityCountries {
            id
            name
          }
          attributes {
            originCountries {
              id
              name
            }
            scientificName {
              id
              name
            }
            inspectionType {
              id
              name
            }
            overseasCertIDs
            phytoIsInspectionOnOriginal
            phytoIsOriginalCert
            phytoIsOriginalContainer
            phytoIsRepacked
            phytoPackhouse
            speciesCommonName {
              id
              name
            }
            expiryDateFrom
            expiryDateTo
            productionBatchIds
            temperature {
              id
              name
            }
            NZHSCode {
              id
              name
            }
            intendedUse {
              id
              name
            }
            grossVolume {
              unit {
                id
                name
              }
              value
            }
            grossWeight {
              unit {
                id
                name
              }
              value
            }
            netVolume {
              unit {
                id
                name
              }
              value
            }
            netWeight {
              unit {
                id
                name
              }
              value
            }
            origin {
              id
              name
            }
            phytoGrowers
            phytoBotanicalName {
              id
              name
            }
            phytoCommonName {
              id
              name
            }
            phytoClass {
              id
              name
            }
            phytoSubClass {
              id
              name
            }
            phytoEndPointInspectionRef
            phytoSupplier
            phytoInspectionLocation
            phytoObservation
            phytoVariety
            phytoApprovedSeedCategory {
              id
              name
            }
            phytoLableDescription {
              id
              name
            }
            phytoPercentageByWeight
            phytoQuantityMeasure {
              unit {
                id
                name
              }
              value
            }
            phytoQuantityType {
              id
              name
            }
            phytoSeedLotReference
            phytoSeedLotApproval {
              id
              name
            }
            phytoMixtureName
          }
          productStatement
          productReference
          tradeLineGroupNumber
          quantity {
            value
            unit {
              id
              name
            }
          }
          containers {
            number
            seals
            id
          }
          packaging {
            quantity
            level
            itemMarksOuter
            packageType {
              id
              name
            }
            nominalGrossWeight {
              unit {
                id
                name
              }
              value
            }
            nominalGrossVolume {
              unit {
                id
                name
              }
              value
            }
          }
          sourceProcessCount
          processes {
            id
            sequenceNumber
            isSourceProcess
            processType {
              id
              name
            }
            premises {
              id
              name
              registrationId
            }
            foreignPremises
            foreignPremisesIdentifier
            endDate
            startDate
            overrideProcessDate
            nameOverride
            foreignPremisesCountryID {
              id
              name
            }
            updatedAt
            processGroup
            attributes {
              additionalTreatment
              chemicalDetail
              concentration
              duration {
                unit {
                  id
                  name
                }
                value
              }
              temperature {
                value
                unit {
                  id
                  name
                }
              }
            }
          }
          processHistory {
            createdAt
            dateOverride
            earliestStartDate
            id
            latestEndDate
            owned
            premisesIdentifier
            premisesName
            processCategory
            processCode
            processName
            lastProcessStartDate
            lastProcessEndDate
            concatenated
            latestSubmissionDate
            processSequenceNumber
            nameOverride
          }
          sources {
            id
            sequenceNumber
            isExhausted
            transferRequestId
            transferRequestNumber
            isPaperSourced
            details {
              itemDescription {
                id
                name
              }
              eligibilityCountries {
                id
                name
              }
              classification {
                classificationCode
                classificationName
                createdAt
                fieldUniqueId
                id
                itemCode
                updatedAt
                value
              }
              attributes {
                expiryDateFrom
                expiryDateTo
                inspectionType {
                  id
                  name
                }
                intendedUse {
                  id
                  name
                }
                netVolume {
                  unit {
                    id
                    name
                  }
                  value
                }
                netWeight {
                  unit {
                    id
                    name
                  }
                  value
                }
                NZHSCode {
                  id
                  name
                }
                origin {
                  id
                  name
                }
                scientificName {
                  id
                  name
                }
                speciesCommonName {
                  id
                  name
                }
                temperature {
                  id
                  name
                }
                productionBatchIds
              }
              packaging {
                quantity
                itemMarksOuter
                outermostNumberOfPacakges
                packageType {
                  id
                  name
                }
                level
                nominalGrossVolume {
                  unit {
                    id
                    name
                  }
                  value
                }
                nominalGrossWeight {
                  unit {
                    id
                    name
                  }
                  value
                }
              }
              containers {
                id
                number
                seals
              }
              productReference
              productStatement
            }
          }
          supportingDocuments {
            id
            status
            documentNumber
            documentReferenceNumber
            comment
            isInherited
            fileId
            primaryOperator {
              id
            }
            intendedOperators {
              id
            }
          }
        }
      }
      declarations {
        id
        selected
        statementCode
        inputs {
          id
          inputValue
          sequenceNumber
        }
      }
      sourceTransfer {
        sourceTransferId
        requestNumber
        approvalDate
      }
    }
  }
`)

export const getExportRequestHistory = graphql(`
  query GetExportRequestHistory($input: ExportRequestHistoryInput!) {
    getExportRequestHistory(input: $input) {
      id
      exportRequestId
      action
      nzxmlURI
      overseasAuthorityInvolved
      reasonCategories
      reasonForStatusChange
      reasonForReprinting
      replacesId
      status
      substatus
      updatedAt
      templateVersionId
      updatedBy
      updatedBySystem
      updatedByProfileName
      updatedByProfileFullName
      updatedByFullName
    }
  }
`)

export const getDraftCertificateGenerationStatus = graphql(`
  query getDraftCertificateGenerationStatus(
    $input: GetDraftCertificateGenerationStatusInput!
  ) {
    getDraftCertificateGenerationStatus(input: $input) {
      error
      isCompleted
      pdfCertificateUrl
      status
    }
  }
`)
